import { RiffleApplication } from './js/applications/riffle/index.js';
import EventEmitter from './pkg/utils/EventEmitter.js';

let isInit = false;
let animation = null;

async function init () {

  const canvas = document.getElementById('scene-canvas');
  
  if (!canvas) return;

  if (window.innerWidth > 1024) {
    if (isInit) return;
    isInit = true;
    const container = document.getElementById('scene-container');
    const modelURL = container.getAttribute('data-model-url');
  
    if (animation === null) {
      const emitter = new EventEmitter();
      animation = new RiffleApplication(emitter);
      await animation.build(canvas, container);
    }
    
    if (animation.loadedModel === null) {
      await animation.loadModel(modelURL);
    }
    animation.mount();
  } else {
    if (!isInit || animation === null) return;
    isInit = false;
    animation.unmount();
  }
  
}

addEventListener("load", async (event) => {
  await init()
})

document.addEventListener('swupcontentreplaced', async (event) => {
  await init()
})

window.addEventListener('resize', async () => {
  init()
})
